import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { ContactCard } from 'advenio-components'

const InventorySection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex:1;
  flex-direction: column;
`

const PanelSection = styled.div`
  display: flex;
  min-height: 96px;
  flex: 1;
  justify-content: flex-start;
  padding: 8px;
  border-bottom: ${props => props.border ? 'solid 1px' : ''};
  border-bottom-color: #CCCCCC;
  border-top: ${props => props.top ? 'solid 1px' : ''};
  border-top-color: #CCCCCC;
  flex-direction: column;
  background: white;
`
const SectionName = styled.span`
  font-size: 14px;
  color:#a0a0a0;
`
const InventoryRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  margin: 16px 0 0 0;
`
const DivWithIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex:1;
`
const Icon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 4px;
  cursor: pointer;
`
const StyledSpan = styled.span`
  font-size: 12px;
  text-align: ${({ right }) => right ? 'right' : 'left'};
  min-width: 15px;
`

const MedicineHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
const MedicineContainer = styled.div`
  background-color: #E2E8EC;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1 1;
  flex-direction: column;
  margin: 4px 0px;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  font-size: 12px;

  span:nth-child(1) {
    font-size: 14px;
    font-weight: bold;
    color: red;
  }
`

const Profile = ({ child, medicines, onMedicineClick, onAddMedicineClick ,isDisenrolled}) => (
  <div>
    <PanelSection border top>
      <InventorySection>
        <SectionName>INFORMACIÓN</SectionName>
        {child.contract.type === 'ContractProduct' && <InventoryRow>
          <DivWithIcon>
            <Icon src="/assets/office.svg" alt="clock" />
            <StyledSpan>
              Empresa/Convenio
            </StyledSpan>
          </DivWithIcon>
          <StyledSpan right>
            {child.contract.company} / {child.contract.contract}
          </StyledSpan>
        </InventoryRow>}
        <InventoryRow>
          <DivWithIcon>
            <Icon src="/assets/cake.svg" alt="diaper" />
            <StyledSpan>
              Fecha de Nacimiento
            </StyledSpan>
          </DivWithIcon>
          <StyledSpan right>
            {child.birth_date && moment(child.birth_date).format('DD MMM YYYY')}
            {/* {props.profile.diaper_count} */}
          </StyledSpan>
        </InventoryRow>
      </InventorySection>
    </PanelSection>
    <PanelSection border>
      <InventorySection>
        <SectionName>INVENTARIO</SectionName>
        <InventoryRow>
          <DivWithIcon>
            <Icon src="/assets/clock_icon.svg" alt="clock" />
            <StyledSpan>
              Product
            </StyledSpan>
          </DivWithIcon>
          <StyledSpan>
            {child.contract.product}
          </StyledSpan>
        </InventoryRow>
        <InventoryRow>
          <DivWithIcon>
            <Icon src="/assets/diaper_icon.svg" alt="diaper" />
            <StyledSpan>
              Pañales
            </StyledSpan>
          </DivWithIcon>
          <StyledSpan>
            {child.diaper_count}
          </StyledSpan>
        </InventoryRow>
      </InventorySection>
    </PanelSection>
    <PanelSection border>
      <InventorySection>
        <MedicineHeader>
          <SectionName>MEDICAMENTOS</SectionName>
          <input
            type="image"
            src="/assets/blue_plus.svg"
            alt="diaper"
            onClick={onAddMedicineClick}
            disabled={ Boolean(isDisenrolled)}
          />
        </MedicineHeader>
        {medicines.length > 0 && medicines.map(medicine => (
          <MedicineContainer
            id={medicine.id}
            key={medicine.id}
            onClick={() => { if (onMedicineClick) onMedicineClick(medicine.id) }}
          >
            <span>{medicine.name}</span>
            <span>Dosis: {medicine.dose}</span>
            <span>{`de: ${moment(medicine.from_date).format('DD MMM YYYY')} a: ${moment(medicine.to_date).format('DD MMM YYYY')}`}</span>
            <span>{medicine.comments}</span>

          </MedicineContainer>
        ))}

      </InventorySection>
    </PanelSection>
  </div>
)

export default Profile



// WEBPACK FOOTER //
// ./src/Containers/ParentPlatform/Profile.jsx